// External libraries
import { css } from '@emotion/core';

// Internal modules
import {
  DISABLED_BACKGROUND_COLOR,
  DISABLED_BORDER_COLOR,
  HEADER_COLOR,
} from '@/styles';

const containerStyles = css`
  background-color: ${DISABLED_BACKGROUND_COLOR};
  border-color: ${DISABLED_BORDER_COLOR};

  > select {
    color: ${HEADER_COLOR};
  }
`;

const pageInfoStyles = {
  container: css({ marginBottom: '12px' }),
  message: css({ fontWeight: 'normal' }),
};

export { containerStyles, pageInfoStyles };
